/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
<div>
    <v-data-table v-show="showTable"
      :headers="computedHeaders"
      :items="dataSet"
      hide-actions
      class="elevation-1 report-fixed-header">
      <template slot="items" slot-scope="props">
          <!-- <td  v-for="x in headers" :key="x.value">{{  x.value === 'Breaker Status' || x.value === 'SPD Status' ? (props.item[x.value] === null ? 'NA' : (props.item[x.value] === 1 ? 'OFF' : 'ON')) : props.item[x.value]  }} </td> -->
          <td  v-for="x in headers" :key="x.value">{{ x.value === 'Breaker Status' || x.value === 'SPD Status' ? (props.item[x.value] === null ? 'NA' :  props.item[x.value]) : props.item[x.value] }} </td>
      </template>
    </v-data-table>
    <!-- <div v-show="showTable" class="text-xs-center pt-2">
      <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
    </div> -->
  </div>
</template>

<script>
import _ from 'lodash'
import { EventBus } from '@/services/event-bus'

export default {
  data () {
    return {
      search: '',
      pagination: {
        rowsPerPage: 15
      },
      selected: [],
      showTable: false,
      headers: [],
      dataSet: []
    }
  },
  mounted () {
    EventBus.$on('reportData', this.tableData)
    EventBus.$on('selectionChanged', this.selectionChanged)
    EventBus.$on("plantChanged", this.plantChange)
    EventBus.$on("changeInterval", this.changeInterval)
  },
  destroyed () {
    EventBus.$off('reportData', this.tableData)
    EventBus.$off("plantChanged", this.plantChange);
    EventBus.$off("changeInterval", this.changeInterval)
  },
  methods: {
    selectionChanged() {
      this.showTable = false
    },
    tableData (data) {
      this.headers = this.createHeader(data[0])
      this.dataSet = data
      this.showTable = true
    },
    plantChange(plantId) {
      this.showTable = false
      this.plantId = plantId
    },
    createHeader (data) {
      let tempHeader = []
      Object.keys(data).forEach((key) => {
        tempHeader.push({ text: key, value: key })
      })
      return tempHeader
    },
    changeInterval(){
      this.showTable = false
      this.dataSet = []
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.dataSet.length / this.pagination.rowsPerPage)
    },
    computedHeaders() {
      const clonedHeader = _.cloneDeep(this.headers)
      return clonedHeader.map(el => {
        el['text'] = this.$t(el.text)
        return el
      })
    }
  }
}
</script>

<style>
.report-fixed-header{
  max-height: 500px
}

.report-fixed-header table.v-table tbody tr td{
    height: 32px;
  }

  .report-fixed-header table.v-table thead tr {
    height: 48px;
  }

.report-fixed-header {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden
}
.report-fixed-header table {
  table-layout: fixed;
}
.theme--dark .report-fixed-header th {
  position: sticky;
  top: 0;
  z-index: 5;
  width: 155px;
  /* background: #212846; */
}
.theme--light .report-fixed-header th {
  position: sticky;
  top: 0;
  z-index: 5;
  width: 155px;
  /* background: #F8F8F8; */
}
.report-fixed-header th:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
}
.report-fixed-header tr.v-datatable__progress th {
  height: 1px;
}
.report-fixed-header .v-table__overflow {
  flex-grow: 1;
  flex-shrink: 1;
  overflow-x: auto;
  overflow-y: auto;
}
.report-fixed-header .v-datatable.v-table {
  flex-grow: 0;
  flex-shrink: 1;
}
.report-fixed-header .v-datatable.v-table .v-datatable__actions {
  flex-wrap: nowrap;
}
.report-fixed-header .v-datatable.v-table .v-datatable__actions .v-datatable__actions__pagination {
  white-space: nowrap;
}
</style>
